import { getBookIdWithPrefix } from "../../utils/content/content";

export const parseResponseBibleContents = (response) => {
  if (response.data.paragraphs) {
    return response.data.paragraphs.map((item) => {
      return {
        ...item,
        bookId: getBookIdWithPrefix(item.para_id),
        paraId: item.para_id,
      };
    });
  }
  return [];
};

export const parseResponseContentPreview = (response) => {
  let outData = [];
  if (response.data.original) {
    outData.push(response.data.original);
  }
  if (response.data.translations) {
    outData.push(...response.data.translations);
  }
  return outData.map((item) => {
    return {
      ...item,
      bookId: getBookIdWithPrefix(item.para_id),
      paraId: item.para_id,
    };
  });
};

export const parseResponseCheckContentVersion = (response) => response.data?.version;
